const BrandLogo: React.FC = () => {
  return <img height="32" alt="Colette" src="/images/colette_logo.png" />;
};

export default BrandLogo;
